import React from 'react'
import './style.scss'
import {connect} from 'react-redux'
import {
    Icon
} from 'antd'
class Footer extends React.Component{
    constructor(props){
        super(props);
        this.state = {

        }
    }
    render(){
        const {content, isLoading} = this.props.Content
        if(content){
            const {overlay, images} = content.Carousel
            const {items} = content.navbar
            return(
                <div className="footer">
                    <div className="wrap">
                        <div className="left">
                            <p className="copyright">
                                Copyright &c 2020
                            </p>
                        </div>
                        <div className="center">
                        <div className="contact">
                                <div className="item">
                                    <Icon className="email" type="mail" />
                                    <p className="">
                                        {overlay.email}
                                    </p>
                                </div>
                                <div className="item">
                                    <Icon className="phone" type="phone" />
                                    <p className="">
                                        {overlay.phone}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="vl"></div>
                        <div className="right">
                            {items.map(item => 
                                 <a className="item" href="#" onClick={() => this.props.tab(item.key)}>{item.text}</a>
                            )}
                        </div>
                    </div>
                </div>
            )
        }else{
            //spin
            return(
                <div className=""></div>
            )
        }
    }
}

const mapStateToProps = (store) => ({
    Content: store.content
  })
  export default connect(mapStateToProps)(Footer);